const initHokoRelatedProductCardSwiper = (productCard) => {
  const productBlock = productCard.closest('.product-block')
  const jsonScript = productBlock?.querySelector('script[type="application/json"]')
  if (!jsonScript) return

  const GROUPING_OPTION_INDEX = 0
  let dataJSON

  try {
    dataJSON = JSON.parse(jsonScript.textContent)
  } catch {
    return
  }

  if (!dataJSON) return

  const optionNameMediaMap = {}

  dataJSON.variants.forEach((variant) => {
    if (variant.featured_media) {
      if (!optionNameMediaMap[variant.options[GROUPING_OPTION_INDEX]]) {
        optionNameMediaMap[variant.options[GROUPING_OPTION_INDEX]] = variant.featured_media.id
      }
    }
  })

  let currentMediaOptionName = ''

  productCard.querySelectorAll('.product-card--swiper .product-card--swiper-slide').forEach((item) => {
    for (const optionName in optionNameMediaMap) {
      if (parseInt(item.getAttribute('data-media-id'), 10) === parseInt(optionNameMediaMap[optionName], 10)) {
        currentMediaOptionName = optionName
      }
    }

    item.setAttribute('data-variant-image-group', currentMediaOptionName)
  })

  const swiperEl = productCard.querySelector('.swiper')
  if (!swiperEl || swiperEl.swiper) return

  new Swiper(swiperEl, {
    loop: false,
    spaceBetween: 0,
    slidesPerView: 1,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: productCard.querySelector('.swiper-button-next'),
      prevEl: productCard.querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: productCard.querySelector('.product-card--swiper-pagination'),
      clickable: true,
    },
  })
}

const refreshHokoRelatedImages = (section) => {
  const images = section.querySelectorAll('.rimage__image')

  images.forEach((image) => {
    if (image.classList.contains('lazyload') || image.classList.contains('lazyloading')) {
      if (typeof lazySizes !== 'undefined' && lazySizes.loader?.unveil) {
        lazySizes.loader.unveil(image)
      }
    }
  })

  if (typeof lazySizes !== 'undefined' && lazySizes.autoSizer?.checkElems) {
    lazySizes.autoSizer.checkElems()
  }
}

const initHokoRelatedProductCards = (section) => {
  const shopifySection = section.closest('.shopify-section') || section
  const initSwiper = window.initSwiperMedia || initHokoRelatedProductCardSwiper

  section.querySelectorAll('.product-card--swiper').forEach((productCard) => {
    const swiperEl = productCard.querySelector('.swiper')
    if (!swiperEl || swiperEl.swiper) return

    initSwiper(productCard)
  })

  if (typeof window.handlePaginationCustom === 'function') {
    window.handlePaginationCustom()
  }

  if (typeof window.initQuickBuyButtons === 'function') {
    window.initQuickBuyButtons(section)
  }

  if (typeof theme !== 'undefined' && theme.ProductBlockManager?.loadImages) {
    theme.ProductBlockManager.loadImages(shopifySection)
  }

  refreshHokoRelatedImages(section)
}

const initHokoRelatedProductsAutoSwiper = (section) => {
  const swiperEl = section.querySelector('.swiper-related')
  if (!swiperEl) return

  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true)
  }

  new Swiper(swiperEl, {
    loop: false,
    spaceBetween: 8,
    slidesPerView: 'auto',
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: section.querySelector('.swiper-button-next-related'),
      prevEl: section.querySelector('.swiper-button-prev-related'),
    },
    pagination: {
      el: section.querySelector('.swiper-pagination-related'),
      type: 'bullets',
      clickable: true,
    },
  })
}

const initHokoRelatedProductsAutoSection = (section) => {
  initHokoRelatedProductCards(section)
  initHokoRelatedProductsAutoSwiper(section)

  requestAnimationFrame(() => {
    refreshHokoRelatedImages(section)
  })
}

const loadHokoRelatedProductsAuto = (section) => {
  const url = section.dataset.url
  if (!url || section.dataset.hokoRelatedLoaded === 'true') return

  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const container = document.createElement('div')
      container.innerHTML = html
      const fetchedSection = container.querySelector('[data-hoko-related-auto]')

      if (!fetchedSection || !fetchedSection.innerHTML.trim()) {
        section.closest('.shopify-section')?.remove()
        return
      }

      section.innerHTML = fetchedSection.innerHTML
      section.dataset.hokoRelatedLoaded = 'true'

      requestAnimationFrame(() => {
        initHokoRelatedProductsAutoSection(section)
      })
    })
    .catch(() => {
      section.closest('.shopify-section')?.remove()
    })
}

const bootHokoRelatedProductsAuto = () => {
  document.querySelectorAll('[data-hoko-related-auto]').forEach((section) => {
    if (section.innerHTML.trim()) {
      section.dataset.hokoRelatedLoaded = 'true'
      requestAnimationFrame(() => {
        initHokoRelatedProductsAutoSection(section)
      })
      return
    }

    loadHokoRelatedProductsAuto(section)
  })
}

const bootWhenReady = () => {
  if (typeof Swiper === 'undefined') {
    setTimeout(bootWhenReady, 50)
    return
  }

  bootHokoRelatedProductsAuto()
}

document.addEventListener('DOMContentLoaded', bootWhenReady)

document.addEventListener('shopify:section:load', (event) => {
  const section = document.querySelector(
    `[data-section-id="${event.detail.sectionId}"][data-hoko-related-auto]`
  )

  if (section) {
    delete section.dataset.hokoRelatedLoaded
    loadHokoRelatedProductsAuto(section)
  }
})
